import React from "react";
import { LoaderOverlay } from "oolib";
import { useGetQueryData } from "@/utils/react-query-hooks/general";
import { UploadButtonAndPreview } from "@/pageTpls/PlatformBuilder/comps/BatchRegisterPage/comps/UploadButtonAndPreview";
import { getIntegrationInterface } from "../IntegrationInterfaces";

/**
 * Add-data step of the compact import flow (body only — rendered inside the
 * shared ImportModalShell). CSV/Excel renders the file uploader; any external
 * source id renders that adapter's integration interface.
 */
export const AddDataView = ({
  selectedDataSource,
  onFileSelect,
  onExternalSourceSubmit,
  isUploading,
  isFetchingExternal,
  externalSubmitError,
  onClearSubmitError,
  contentType,
}) => {
  const platformConfigs = useGetQueryData("platformConfigs");
  const allAdapters =
    platformConfigs?._DirectDataImport?.EXTERNAL_IMPORT_ADAPTERS_CONFIG || [];

  const isCsv = selectedDataSource === "csvExcelUpload";
  const adapterConfig = allAdapters.find((a) => a.id === selectedDataSource);
  const IntegrationInterface = getIntegrationInterface(selectedDataSource);

  return (
    <>
      {isUploading && <LoaderOverlay loaderText="Processing file..." />}
      {isFetchingExternal && (
        <LoaderOverlay loaderText="Fetching data from external source..." />
      )}

      {isCsv ? (
        <UploadButtonAndPreview onFileSelect={onFileSelect} />
      ) : adapterConfig ? (
        <IntegrationInterface
          adapterConfig={adapterConfig}
          // Interfaces emit { apiKey?, adapterOptions } without the source id, so
          // inject it here (DataSourceSelector did the same).
          onSubmit={({ apiKey, adapterOptions }) =>
            onExternalSourceSubmit({
              sourceId: selectedDataSource,
              apiKey,
              adapterOptions,
            })
          }
          isLoading={isFetchingExternal}
          submitError={externalSubmitError}
          onClearSubmitError={onClearSubmitError}
          contentType={contentType}
        />
      ) : null}
    </>
  );
};

export default AddDataView;
